import { Button, Card, CardActions, CardContent, CardHeader, Chip, Link, makeStyles, MuiThemeProvider, Typography } from '@material-ui/core';
import { InfoRounded } from '@material-ui/icons';
import isEmpty from 'lodash.isempty';
import { openChatState, SUPPORT_CHAT } from 'pages/CustomerBooking';
import React, { useEffect, useMemo, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { yiq } from 'yiq';
import Themes from "src/themes";
import './statuscard.css'
import { useTrackEvent } from 'util/trackEvent';
const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: '#E4B3AC'
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
    },
    textContent: {
      marginLeft: theme.spacing(1)
    },
    link: {
      cursor: 'pointer'
    },
    title: {
      // animation: "blur .75s ease-out infinite",
      // textDecoration: "underline",
      fontWeight: 700,
      textTransform: 'uppercase',
      fontSize: "x-large",
    },
    cbox: {
      background: "linear-gradient(-45deg,#ffffff 0%,#ffffff 25%,#E4B3AC 25%,#E4B3AC 50%,#ffffff 50%,#ffffff 75%,#E4B3AC 75%,#E4B3AC 100%)",
      backgroundSize: "40px 40px",
      height:5,
      animation: "move 2s linear infinite",
    }
  }
})
const StatusCardPreflight = ({ booking }) => {
  const classes = useStyles()
  const setChatOpen = useSetRecoilState(openChatState);
  const trackEvent = useTrackEvent()
  const preflightMessages = useMemo(() => {
    let pfM = ''
    const filtererdPkgTests = booking?.extended_package_items?.filter(
      (pkg) => [
        'service.blood_test_specimen.RBS',
        'service.blood_test_specimen.CORTISOL',
        // 'service.blood_test_specimen.LIPID_PROFILE'
      ].includes(pkg?.item?.name)
    )

    return filtererdPkgTests?.map((pkg) => {
      const content = <Typography>If you have any questions, <Link color="inherit" className={classes.link} underline="always" onClick={() => {
        trackEvent('Booking Details - Preflight - Support Chat Opened', {item:  pkg?.item?.name})
        setChatOpen(SUPPORT_CHAT)}
      }><strong>click here</strong></Link> to speak to our customer support</Typography>
      switch (pkg?.item?.name) {
        case 'service.blood_test_specimen.FBS':
          return { title: "Fasting required", subtitle: 'Fasting Blood Sugar', content }
        case 'service.blood_test_specimen.LIPID_PROFILE':
          return { title: "Fasting required", subtitle: 'Lipid Profile', content }
        case 'service.blood_test_specimen.CORTISOL':
          return { title: "Perform test early in the morning", subtitle: 'Cortisol', content }
        default:
          return {}
      }
    })

  }, [booking]);

  if (isEmpty(preflightMessages)) {
    return <></>
  }
  return <>
    {
      preflightMessages?.filter(it=>it?.title)?.map((it, key) => (
        <Card className={classes.root} key={key}>
          <div className={classes.box} />
          <CardHeader classes={{
            title: classes.title,
          }} title={it?.title} subheader={it?.subtitle} />
          <CardContent className={classes.content}>
            <InfoRounded />
            <div className={classes.textContent}>
              {it?.content}
            </div>
          </CardContent>
          {/* <CardActions>
            <Button color="default"
              variant="contained"
              onClick={() => {
                setChatOpen(SUPPORT_CHAT)
              }}
            >Speak to our customer support for more info</Button>
          </CardActions> */}
        </Card>
      ))
    }
  </>
}

const WrappedCard = ({ booking, ...props }) => {
  const colorYiq = yiq(`#E4B3AC`, { threshold: 128 })
  const theme = colorYiq === '#000' ? Themes.dark : Themes.default
  return (
    <MuiThemeProvider theme={theme}>
      <StatusCardPreflight booking={booking} {...props} />
    </MuiThemeProvider>
  )
}
export { WrappedCard as StatusCardPreflight };
